import { Link } from 'react-router';
import { useI18n } from '../i18n/i18n';
import { cn } from '../lib/cn';

/** Знак продукта — тот же, что `public/favicon.svg`: синий скруглённый квадрат с буквой «A». */
export function BrandMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={cn('shrink-0', className)}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="7" fill="var(--primary)" />
      <path
        fill="var(--control-fg)"
        transform="translate(6.5 6) scale(1.1)"
        d="M11.7201 14.76H5.41339L4.00395 18.6H0.277283L6.39284 2.28003H11.0273L16.9995 18.6H13.0817L11.7201 14.76ZM10.6451 11.688L8.63839 5.97603L6.53617 11.688H10.6451Z"
      />
    </svg>
  );
}

interface BrandProps {
  /** Куда ведёт знак: с домашнего экрана — на лендинг, со схемы — к списку схем. */
  to: string;
  /** Подсказка при наведении: «На главную», «К списку схем». */
  title?: string;
  /** С надписью — на лендинге и домашнем экране; на экране схемы рядом стоит её название. */
  wordmark?: boolean;
  className?: string;
}

/** Знак со ссылкой. Название продукта — один ключ словаря `app.name`. */
export function Brand({ to, title, wordmark = false, className }: BrandProps) {
  const { t } = useI18n();
  return (
    <Link
      to={to}
      aria-label={t('app.name')}
      {...(title !== undefined ? { title } : {})}
      className={cn(
        'inline-flex items-center gap-2 rounded-lg text-foreground no-underline outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
        className,
      )}
    >
      <BrandMark />
      {wordmark && <span className="text-lg font-semibold tracking-tight">{t('app.name')}</span>}
    </Link>
  );
}
